var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{attrs:{"data":_vm.tableData,"thead-classes":"text-primary"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(row.title))])]),_c('td',{staticClass:"td-actions text-right"},[_c('base-button',{attrs:{"type":"link","aria-label":"edit button"}},[_c('i',{staticClass:"tim-icons icon-pencil"})])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }